export const HttpConstants = {
  CANCEL_REQUEST: "canelRequest"
};
